import { IconChevronLeft } from '@tabler/icons-react-native';
import { Button } from 'app/design/primitives/button';
import { useNavigation } from 'app/hooks/navigation';
import { useTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

export function HeaderLeftBack() {
  const theme = useTheme();
  const navigation = useNavigation();
  return (
    <Button onPress={() => navigation.goBack()}>
      <IconChevronLeft strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['white-label.header.on-header']} />
    </Button>
  );
}
